module.exports = __webpack_public_path__ + "fonts/iconfont.9f576182.woff2";